export default "__VITE_ASSET__D9zpHUsB__"